module.exports = __webpack_public_path__ + "media/birthday_tier_3-92b74f1e58ac774ca2c2201995ec82d6.mp3";